import React, { useContext, useRef } from "react";
import styled from "styled-components";
import InputMask from "react-input-mask";
import Swal from "sweetalert2";
import { Button, Col, Container, Row } from "reactstrap";
import { DocumentTypeContext } from "../../context/DocumentContext";
import TextField from "@mui/material/TextField";
import styledMui from "@mui/system/styled";
import { Tooltip } from "@mui/material";
import { useLocation } from "react-router-dom";
import { Checkbox, FormControlLabel } from "@mui/material";
import InputStandard from "../Inputs/InputStandard";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import ReactDOM from "react-dom";

const CustomTextField = styled(TextField)({
  "& label": {
    color: "#75788D",
  },
  "& label.Mui-focused": {
    color: "#75788D",
  },
  "& .MuiInput-underline:before": {
    borderBottomColor: "#F9B233",
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
    borderBottomColor: "#F9B233",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#F9B233",
  },
});

const TodoList = ({
  onAddSignature,
  onAddDate,
  onAddText,
  onReset,
  setPageNum,
  onSelectCollaborator,
  saveSigners,
  updateSigners,
  routeSign,
}) => {

  const { setNameDocument, nameDocument, idEditDocument, setCollaborators, collaborators } =
    useContext(DocumentTypeContext);

  const [newCollaborator, setNewCollaborator] = React.useState("");
  const [newCollaboratorName, setNewCollaboratorName] = React.useState("");
  const [newCollaboratorPhoneNumber, setNewCollaboratorPhoneNumber] =
    React.useState("");
  const [addToContacts, setAddToContacts] = React.useState(true);
  const [selectedFieldType, setSelectedFieldType] = React.useState("email");

  const firstSteps = [
    {
      target: "#document-name-input",
      content: "Digite o nome do documento que será assinado.",
      placement: "top",
      disableBeacon: true,
    },
    {
      target: "#signer-name-input",
      content:
        "Insira o nome do signatário (pessoa que irá assinar o documento).",
      placement: "top",
      disableBeacon: true,
    },
    {
      target: "#signer-email-input",
      content:
        "Informe o e-mail do signatário para que ele possa receber o documento.",
      placement: "top",
      disableBeacon: true,
    },
    {
      target: "#signer-phone-input",
      content: "Você pode adicionar o telefone do signatário (opcional).",
      placement: "top",
      disableBeacon: true,
    },
    {
      target: "#add-signer-button",
      content:
        "Clique aqui para adicionar o signatário à lista de assinaturas do documento.",
      placement: "top",
      disableBeacon: true,
    },
  ];

  // const secondSteps = [
  //   {
  //     target: "#posicionar-assinatura-button",
  //     content:
  //       "Clique aqui para iniciar o posicionamento da assinatura no documento.",
  //     placement: "top",
  //     disableBeacon: true,
  //   },
  //   {
  //     target: "#document-page",
  //     content: "Clique na área do documento onde deseja colocar a assinatura.",
  //     placement: "auto",
  //     disableBeacon: true,
  //   },
  // ];


  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidPhone = (phone) => /^\(\d{2}\) \d{5}-\d{4}$/.test(phone);
  const containerRef = useRef(null);

  const handleAddCollaborator = () => {
    if (newCollaboratorName.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Por favor, insira um nome válido.",
      });
      return;
    }

    const isValidInput =
      (selectedFieldType === "email" && isValidEmail(newCollaborator.trim())) ||
      (selectedFieldType === "phone" && isValidPhone(newCollaborator.trim()));

    if (isValidInput) {
      setCollaborators([
        ...collaborators,
        {
          id: collaborators.length + 1,
          name: newCollaboratorName,
          email: newCollaborator,
          phoneNumber: newCollaboratorPhoneNumber,
          addToContacts: addToContacts,
          signature: "",
          date: "",
          fieldType: selectedFieldType,
        },
      ]);

      setNewCollaborator("");
      setNewCollaboratorName("");
      setNewCollaboratorPhoneNumber("");
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: `Por favor, insira um ${
          selectedFieldType === "email" ? "e-mail" : "número de telefone"
        } válido.`,
      });
    }
  };

  const handleDeleteCollaborator = (index) => {
    const updatedCollaborators = [...collaborators];
    updatedCollaborators.splice(index, 1);
    setCollaborators(updatedCollaborators);
  };

  return (
    <div ref={containerRef} style={{}} className="todo-list-container">
      {/* <Joyride
        steps={tourStep === 1 ? firstSteps : secondSteps}
        run={run}
        continuous
        showSkipButton
        showProgress
        callback={handleJoyrideCallback}
        locale={{
          back: "Voltar",
          close: "Fechar",
          last: "Finalizar",
          next: "Próximo",
          skip: "Pular",
          step: "Passo",
          of: "de",
        }}
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: "#FFB800",
            textColor: "#333",
            arrowColor: "#fff",
            backgroundColor: "#fff",
          },
        }}
      /> */}

      {/* <CustomTextField
        disabled={idEditDocument}
        value={nameDocument}
        onChange={(e) => setNameDocument(e.target.value)}
        id="document-name-input"
        label="Nome do Documento"
        variant="standard"
        style={{ marginBottom: "20px" }}
        fullWidth
      /> */}

      {/* <p
        style={{
          fontSize: "15px",
          color: "#75788D",
          marginTop: "10px",
          fontWeight: "bold",
        }}
      >
        Adicionar signatário
      </p> */}

      {/* <CustomTextField
        value={newCollaboratorName}
        onChange={(e) => setNewCollaboratorName(e.target.value)}
        id="signer-name-input"
        label="Nome do signatário"
        variant="standard"
        fullWidth
        style={{ marginBottom: "20px" }}
      /> */}

      {/* Email do Documento */}
      {/* <CustomTextField
        value={newCollaborator}
        onChange={(e) => setNewCollaborator(e.target.value)}
        label="E-mail"
        id="signer-email-input"
        variant="standard"
        fullWidth
        style={{ marginBottom: "20px" }}
      /> */}

      {/* Telefone */}
      {/* <InputStandard
        variant="standard"
        search
        type="tel"
        name="phoneNumber"
        id="signer-phone-input"
        mask="(99) 99999-9999"
        handleChange={(e) => setNewCollaboratorPhoneNumber(e.target.value)}
        value={newCollaboratorPhoneNumber}
        label="Telefone"
      /> */}

      {/* <FormControlLabel
        control={
          <Checkbox
            checked={addToContacts}
            onChange={(e) => setAddToContacts(e.target.checked)}
            color="primary"
            id="add-to-contacts-checkbox"
          />
        }
        label="Adicionar signatário aos contatos"
        sx={{
          color: "#75788D",
          fontFamily: '"Poppins", serif',
        }}
        style={{ marginTop: "10px" }}
      /> */}

      {/* Botão de adicionar mais pessoas */}
      {/* <Button
        onClick={handleAddCollaborator}
        id="add-signer-button"
        style={{
          backgroundColor: "#F9B233",
          color: "#fff",
          border: "none",
          padding: "10px 20px",
          borderRadius: "50px",
          display: "flex",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <span style={{ fontSize: "16px", marginLeft: "10px" }}>
          + Signatários
        </span>
      </Button> */}

      {collaborators.map((collaborator, index) => (
        <div
          key={index}
          style={{
            marginTop: "30px",
            padding: "15px",
            border: "1px solid #F9B233",
            borderRadius: "8px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <h6 style={{ color: "#75788D" }}>Assinatura #{index + 1}</h6>
          <p
            style={{
              fontSize: "14px",
              color: "#75788D",
              marginBottom: "5px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "200px",
            }}
          >
            <Tooltip title={collaborator.name} placement="top">
              <span>Nome: {collaborator.name}</span>
            </Tooltip>
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#75788D",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "200px",
            }}
          >
            <Tooltip title={collaborator.email} placement="top">
              <span>Email: {collaborator.email}</span>
            </Tooltip>
          </p>

          {/* <Button
            id="posicionar-assinatura-button"
            onClick={() =>
              onAddSignature(
                index,
                collaborator.name,
                collaborator.email,
                collaborator.phoneNumber,
                collaborator.addToContacts,
                collaborator.typeSign
              )
            }
            style={{
              backgroundColor: "#F9B233",
              color: "#fff",
              border: "none",
              padding: "5px 15px",
              borderRadius: "50px",
              marginRight: "10px",
            }}
          >
            Poscionar Assinatura
          </Button> */}
          {/* <Button
            onClick={() => handleDeleteCollaborator(index)}
            style={{
              marginTop: "10px",
              backgroundColor: "#fff",
              color: "#F9B233",
              border: "1px solid #F9B233",
              padding: "5px 15px",
              borderRadius: "50px",
            }}
          >
            Excluir
          </Button> */}
        </div>
      ))}
    </div>
  );
};

export default TodoList;
